import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDefaultGridProps } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/gridHelpers';
import AgGridReact from 'ui/AgGridReact/AgGridReact';
import { DetailedGradeAdvancementHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/types';
import { getColDefs } from './helpers/colDefinitions';
import NoDataResume from '../NoDataResume';
import { GetRowIdParams } from 'ag-grid-community';
import StyChip from 'routes/HumanResourcesModule/components/ui/StyChip';
import { slugify } from 'helpers/formatHelper';
import {
    getCsvExportFilename,
    getExcelExportFilename,
} from 'routes/HumanResourcesModule/Simulation/helpers/gridHelpers';

type Props = {
    hrSimulationTitle: string;
    gradeAdvancementHypotheses: DetailedGradeAdvancementHypothesis[];
};

const GradeAdvancementResumeGrid = ({
    gradeAdvancementHypotheses,
    hrSimulationTitle,
}: Props) => {
    const { t } = useTranslation();
    const getRowId = useCallback(
        (params: GetRowIdParams) => Object.values(params.data).join('-'),
        [],
    );
    const defaultProps = getDefaultGridProps();
    const exportFileName = t(
        'humanResources.simulation.agentHypothesis.gradeHypothesesResumedataFileName',
        {
            title: slugify(hrSimulationTitle),
        },
    );

    const gridProps = {
        ...defaultProps,
        getRowId,
        sideBar: undefined,
        defaultColDef: {
            flex: 1,
        },
        defaultCsvExportParams: {
            ...defaultProps.defaultCsvExportParams,
            fileName: getCsvExportFilename(exportFileName),
        },
        defaultExcelExportParams: {
            ...defaultProps.defaultExcelExportParams,
            fileName: getExcelExportFilename(exportFileName),
        },
        components: {
            ...defaultProps.components,
            agentHypothesisCellRenderer: StyChip,
        },
    };

    const columnDefs = getColDefs();

    return (
        <>
            {gradeAdvancementHypotheses.length === 0 ? (
                <NoDataResume
                    text={t('humanResources.simulation.noHypotheses')}
                />
            ) : (
                <AgGridReact
                    {...gridProps}
                    rowData={gradeAdvancementHypotheses}
                    columnDefs={columnDefs}
                />
            )}
        </>
    );
};

export default GradeAdvancementResumeGrid;
